import { render, staticRenderFns } from "./CustomField.vue?vue&type=template&id=1c0ac196&scoped=true&"
import script from "./CustomField.vue?vue&type=script&lang=js&"
export * from "./CustomField.vue?vue&type=script&lang=js&"
import style0 from "./CustomField.vue?vue&type=style&index=0&id=1c0ac196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ac196",
  null
  
)

export default component.exports